import React, { useContext, useState } from "react";
import { Button, Input, Select } from "antd";
import "./AddColaborador.css";
import axios from "axios";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import * as links from "../../../../../utils/links";
import LoadingAction from "../../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { SERVIDOR_URL } from "../../../../../utils/constants";

const AddColaborador = (props) => {
  const { Option } = Select;
  const { authInfo, setDataUser, setNotiMessage } = useContext<any>(AuthContext);
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const dateFormat = "YYYY-MM-DD";
  let currentDate = moment();

  const [data, setData] = useState<any>({
    nome: "",
    cpf: "",
    senha: "",
    dataVencimento: currentDate.add(1, "years"),
    permissao: "",
    valorCortesia: 0
  });

  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(false);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const onSave = () => {
    let errorsTemp: any = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }

    if ((!data.cpf.trim() as any) === "" || data.cpf.length < 11) {
      errorsTemp.cpf = "Este campo é obrigatório e deve conter 11 digitos";
    }
    if (data.senha.trim().length < 6) {
      errorsTemp.senha = "A senha deve possuir no mínimo 6 dígitos.";
    }
    if (data.valorCortesia.trim() === "" || data.valorCortesia === 0) {
      errorsTemp.valorCortesia = "Digite o valor padrão da cortesia para este colaborador";
    }
    if (data.permissao.trim() === "") {
      errorsTemp.permissao = "Este campo é obrigatório";
    }


    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios.post(
      `${SERVIDOR_URL}/colaborador`,
      {
        nome: data.nome,
        cpf: data.cpf,
        senha: data.senha,
        clienteId: authInfo.dataUser?.id,
        status: 'ATIVO',
        permissao: data.permissao,
        valorCortesia: parseInt(data.valorCortesia)
      },
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    ).then((res) => {
      setIsLoading(false);
      navigate(links.LISTA_COLABORADORES);
    }).catch((err) => {
      setIsLoading(false);

      setNotiMessage({
        type: "error",
        message: err.response?.data?.error
          ? err.response?.data?.error
          : `A sua sessão expirou, para continuar faça login novamente.`,
      });
    });
  };

  const handleGeneratePassword = () => {
    handleChange("senha", String(Math.floor(100000 + Math.random() * 9000)));
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div className="px-page">
        <div className="px-page-header">
          <h1 className="px-page-title">Cadastro de Colaborador</h1>
          <Link className="px-back-btn" to={links.LISTA_COLABORADORES}>
            VOLTAR
          </Link>
        </div>

        <div className="px-panel">
          <div className="px-panel-header">
            <h2 className="px-panel-title">Dados do colaborador</h2>
          </div>

          <form
            className="px-form-grid"
            onSubmit={(e) => {
              e.preventDefault();
              if (!isLoading) onSave();
            }}
          >
            <div className={`px-field ${errors.nome ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="nome">
                Nome
              </label>
              <Input
                placeholder={"Jukinha da Silva"}
                value={data.nome}
                id="nome"
                type="text"
                name="nome"
                autoComplete="nome"
                onChange={(event) => {
                  handleChange("nome", event.target.value);
                }}
              />
              {errors.nome && <div className="px-field-msg">{errors.nome}</div>}
            </div>

            <div className={`px-field ${errors.cpf ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="cpf">
                CPF
              </label>
              <Input
                placeholder={"000.000.000-00"}
                value={data.cpf}
                id="cpf"
                type="text"
                name="cpf"
                autoComplete="cpf"
                onChange={(event) => {
                  handleChange("cpf", event.target.value);
                }}
              />
              {errors.cpf && <div className="px-field-msg">{errors.cpf}</div>}
            </div>

            <div className={`px-field ${errors.senha ? "px-field-error" : ""}`}>
              <div className="px-field-label">
                <label htmlFor="senha">Senha</label>
                <Button
                  className="px-btn"
                  style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                  onClick={handleGeneratePassword}
                  htmlType="button"
                >
                  <FontAwesomeIcon icon={faArrowsRotate} />
                  Gerar Senha
                </Button>
              </div>
              <Input
                placeholder={"********"}
                value={data.senha}
                id="senha"
                type="text"
                name="senha"
                autoComplete="senha"
                onChange={(event) => {
                  handleChange("senha", event.target.value);
                }}
              />
              {errors.senha && (
                <div className="px-field-msg">{errors.senha}</div>
              )}
            </div>

            <div
              className={`px-field ${
                errors.valorCortesia ? "px-field-error" : ""
              }`}
            >
              <label className="px-field-label" htmlFor="valorCortesia">
                Valor da Cortesia
              </label>
              <Input
                placeholder={"R$0,00"}
                value={data.valorCortesia}
                id="valorCortesia"
                type="number"
                name="valorCortesia"
                autoComplete="valorCortesia"
                onChange={(event) => {
                  handleChange("valorCortesia", event.target.value);
                }}
              />
              {errors.valorCortesia && (
                <div className="px-field-msg">{errors.valorCortesia}</div>
              )}
            </div>

            <div
              className={`px-field ${errors.permissao ? "px-field-error" : ""}`}
            >
              <label className="px-field-label" htmlFor="permissao">
                Permissão
              </label>
              <Select
                value={data.permissao || undefined}
                placeholder="Selecione a permissão"
                onChange={(event) => {
                  handleChange("permissao", event);
                }}
              >
                <Option value="VENDA">Vendas</Option>
                <Option value="CORTESIA">Cortesia</Option>
                <Option value="VENDACORTESIA">Venda / Cortesia</Option>
              </Select>
              {errors.permissao && (
                <div className="px-field-msg">{errors.permissao}</div>
              )}
            </div>
          </form>

          <div className="px-form-actions">
            <Button
              className="px-btn px-btn-primary"
              onClick={() => {
                if (!isLoading) onSave();
              }}
              disabled={isLoading}
            >
              SALVAR
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddColaborador;

